import { render, staticRenderFns } from "./TftPlayer.vue?vue&type=template&id=42dfb02a&scoped=true"
import script from "./TftPlayer.vue?vue&type=script&lang=js"
export * from "./TftPlayer.vue?vue&type=script&lang=js"
import style0 from "./TftPlayer.vue?vue&type=style&index=0&id=42dfb02a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dfb02a",
  null
  
)

export default component.exports